<template>
    <div id="slider-advantages-wrapper" class="cr-popover-left-bottom">
        <HeaderAdvantagesSlider id="slider-advantages"/>

        <div class="cr-popover-content">
            <h4>Vantagens Chico Rei:</h4>
            <ul class="d-flex flex-wrap flex-spaced-fixed">
                <li>
                    <h5>
                        <i class="icon-cr icon-carrier orange"></i>
                        Frete Grátis
                    </h5>
                    <p v-if="$scope.CONFIG.FRETE_VALOR_FIXO_HABILITADO && $scope.CONFIG.FRETE_VALOR_FIXO == 0">
                        Aproveite! Estamos temporariamente com frete grátis para todo o Brasil
                    </p>
                    <p v-else>
                        Em todos os pedidos acima de R${{$scope.CONFIG.VALOR_FRETE_GRATIS}}
                    </p>
                </li>
                <li>
                    <h5>
                        <i class="icon-cr icon-carrier-car orange"></i>
                        Seja Prime!
                    </h5>
                    <p>Frete grátis em todos os pedidos por 1 ano. <a href="/prime" class="text-accent">Saiba mais</a>
                    </p>
                </li>
                <li>
                    <h5>
                        <i class="icon-cr icon-exchange orange"></i>
                        1ª Troca grátis
                    </h5>
                    <p>Sua primeira troca na Chico Rei é por nossa conta!</p>
                </li>
                <li>
                    <h5>
                        <i class="icon-cr icon-credit-card orange"></i>
                        Parcelamento
                    </h5>
                    <p>4x s/ juros no cartão.</p>
                </li>
                <li>
                    <h5>
                        <i class="icon-cr icon-loyalty-card orange"></i>
                        Cartão fidelidade</h5>
                    <p>A cada 10 produtos, ganhe R$50.</p>
                </li>
                <li>
                    <h5>
                        <i class="icon-cr icon-gallery orange"></i>
                        Galeria
                    </h5>
                    <p>A cada foto, receba R${{$scope.CONFIG.GALERIA_VALOR_DESCONTO}} de crédito.</p>
                </li>
                <li>
                    <h5>
                        <i class="icon-cr icon-indicates orange"></i>
                        Indica Chico Rei
                    </h5>
                    <p>A cada indicação = R$5 de crédito</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import HeaderAdvantagesSlider from "./HeaderAdvantagesSlider";

    export default {
        name: "HeaderAdvantages",
        components: {HeaderAdvantagesSlider}
    }
</script>